import { Box, MenuItem, Select, FormControl } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontSize, fontWeight } from '../../theme';

export const FilterTableBoxStyled = styled(Box)`
    &&{
        display: flex;
    }
`;

export const TableCellHeaderStyled = styled(TableCell)`
    && {
        border: none;
        background-color: #F8FAFC;
        font-weight: 500;
        font-family: barlow;
        color: #0F172A;
        line-height: 20px;
        font-size: 16px;
        vertical-align: bottom;
    }

`;

export const TableRowHeaderStyled = styled(TableRow)`
    && {
        display: table-row;
        vertical-align: text-top;
        outline: 0;
        height: 80px;
    }

`;

export const TextFieldDivStyled = styled.div`
    && {
        display: block;
        vertical-align: bottom;
        margin: 0px 5px;
    }

`;

export const TextFieldStyled = styled(TextField)`
    && {
        background-color: transparent;
        width: 100%;
        background-color: ${colors.grey800};
        border-radius: 8px;
        border-bottom: none;
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        font-weight: ${fontWeight.regular};
    }

`;

export const TableRowBodyStyled = styled(TableRow)`
    && {
        border: none;
        &:hover {
            background-color: none;
            transition: background-color 500ms ease-in-out;
        }
    }

`;

export const TableCellBodyStyled = styled(TableCell)`
    && {
        font-family: ${fontFamilyPrimary};
        border: none;
        color: ${colors.grey200};
        font-size: 1em;
        line-height: 5px;
        font-weight: ${fontWeight.semiRegular};
        font-size: ${fontSize.m};
        padding: 9px 20px 9px 0px;
        border-bottom: none;
        line-height: normal;
    }
`;

export const TableContainerStyled = styled.div`
    && {
        height: 56vh;
        min-height: 400px;
        position: relative;
        display: flex;
        flex-direction: column;
        &&::-webkit-scrollbar {
            -webkit-appearance: none;
            height: 8px;
        }
    }
`;

export const StyledSelect = styled(Select)`
    && {
        max-width: 250px;
        ::before {
            display: none;
        }
    }
`;

export const SelectFilterStyled = styled(StyledSelect)`
    && {
        background-color: ${colors.grey800};
        border-bottom: 1px solid;
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        font-weight: ${fontWeight.regular};
        margin: 0;
        .MuiSelect-select {
            &:focus {
                background-color: transparent;
            }

        }
        svg {
            padding-right: 0px;
            &.MuiSelect-iconOpen {
                padding-left: 0px;
            }
        }
    }
`;

export const MenuItemStyled = styled(MenuItem)`
    && {
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        display: flex;
        justify-content: space-between;
        color: ${colors.grey100};

        &&.Mui-selected {
            opacity: 0.7;
        }
    }
`;

export const StyledSelectFormControl = styled(FormControl)`
    && {
        min-width: 180px;
        margin-right: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0;
        width: 180px;
        @media print {
            display: none;
        }
    }
`;

export const TableCellStyled = styled.div(({ paddingcell }: {paddingcell: string}) => `
    && {
        font-family: ${fontFamilyPrimary};
        color: ${colors.grey100};
        font-size: ${fontSize.m};
        padding: ${paddingcell};
        background-color: transparent;
        border: none;
    }

`);
